import _extends from "@babel/runtime/helpers/esm/extends";
/** @jsx jsx */

import { jsx } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default (function (props) {
  return jsx("header", _extends({}, props, {
    sx: {
      position: 'absolute',
      zIndex: 1,
      left: 0,
      top: 0,
      right: 0,
      pointerEvents: 'none',
      variant: 'styles.Header'
    }
  }));
});